/**
 * Status codes observed in the permission-request history contract / tests.
 * Write-flow statuses may appear later when apply/cancel become safe.
 */
const LABELS: Record<string, string> = {
  APPROVED: 'Approved',
  CANCELLED: 'Canceled',
  CANCELED: 'Canceled',
  PENDING: 'Pending approval',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  WITHDRAWN: 'Withdrawn',
  DRAFT: 'Draft',
};

const MESSAGES: Record<string, string> = {
  APPROVED: 'This permission request was approved.',
  CANCELLED: 'This permission request was canceled.',
  CANCELED: 'This permission request was canceled.',
  PENDING: 'This permission request is waiting for approval.',
  SUBMITTED: 'This permission request was submitted.',
  REJECTED: 'This permission request was rejected.',
  WITHDRAWN: 'This permission request was withdrawn.',
  DRAFT: 'This permission request is still a draft.',
};

const CATEGORIES: Record<
  string,
  'neutral' | 'success' | 'warning' | 'danger' | 'info'
> = {
  APPROVED: 'success',
  CANCELLED: 'neutral',
  CANCELED: 'neutral',
  PENDING: 'warning',
  SUBMITTED: 'info',
  REJECTED: 'danger',
  WITHDRAWN: 'neutral',
  DRAFT: 'neutral',
};

export function getTimePermissionStatusLabel(
  status: string | null | undefined,
): string {
  if (!status) return 'Status unavailable';
  return LABELS[status] ?? 'Status unavailable';
}

export function getTimePermissionStatusMessage(
  status: string | null | undefined,
): string {
  if (!status) return 'Permission request status is unavailable.';
  return MESSAGES[status] ?? 'Permission request status is unavailable.';
}

export function getTimePermissionStatusCategory(
  status: string | null | undefined,
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  if (!status) return 'neutral';
  return CATEGORIES[status] ?? 'neutral';
}
